import { request } from "./client";

// ── Signed-in preferences (Profile > Notifications) ─────────────────────────────

/** @returns {Promise<{ unsubscribedAll: boolean, leagues: Array<{ leagueId: string, leagueName: string, remindersEnabled: boolean, scheduleChangesEnabled: boolean, announcementsEnabled: boolean }> }>} */
export const getPreferences = async () => request("/notifications/preferences");

/**
 * @param {{ unsubscribedAll?: boolean, leagues?: Array<{ leagueId: string, remindersEnabled?: boolean, scheduleChangesEnabled?: boolean, announcementsEnabled?: boolean }> }} changes
 */
export const updatePreferences = async (changes) =>
  request("/notifications/preferences", { method: "PATCH", body: JSON.stringify(changes) });

// ── Unsubscribe links from emails (no login; the token identifies the person) ──

export const getUnsubscribeInfo = async (token, leagueId) =>
  request(
    `/notifications/unsubscribe/${encodeURIComponent(token)}${leagueId ? `?leagueId=${encodeURIComponent(leagueId)}` : ""}`
  );

/** @param {"league"|"all"} scope */
export const unsubscribeByToken = async (token, scope, leagueId) =>
  request(`/notifications/unsubscribe/${encodeURIComponent(token)}`, {
    method: "POST",
    body: JSON.stringify({ scope, leagueId }),
  });

/** @param {"league"|"all"} scope */
export const resubscribeByToken = async (token, scope, leagueId) =>
  request(`/notifications/resubscribe/${encodeURIComponent(token)}`, {
    method: "POST",
    body: JSON.stringify({ scope, leagueId }),
  });
